import { createContext } from 'react';
export const routerStartTimeFromTimeOriginRef = { current: 0 };
let isRouterStartTimeUpdaterInitialized = false;
export function initRouterStartTimeUpdater() {
    if (isRouterStartTimeUpdaterInitialized ||
        typeof window === 'undefined' ||
        typeof document === 'undefined')
        return;
    isRouterStartTimeUpdaterInitialized = true;
    window.addEventListener('popstate', () => {
        routerStartTimeFromTimeOriginRef.current = performance.now();
    });
    document.addEventListener('visibilitychange', function onVisible() {
        if (document.visibilityState === 'visible') {
            routerStartTimeFromTimeOriginRef.current = performance.now();
            document.removeEventListener('visibilitychange', onVisible);
        }
    });
}
export const RouterContext = createContext({
    spaRoutes: undefined,
    openNonSpaRouteInNewTab: false,
    startTimeFromTimeOriginRef: routerStartTimeFromTimeOriginRef,
});
RouterContext.displayName = 'RouterContext';
//# sourceMappingURL=RouterContext.js.map